/**
 * Game preview cards: scroll-end CTA (<1024), progress thumb sync.
 */
(function () {
  var DESKTOP_MIN = 1024;
  var END_THRESHOLD = 4;

  function isDesktop() {
    return window.matchMedia('(min-width: ' + DESKTOP_MIN + 'px)').matches;
  }

  function updateProgress(track, thumb, progressWrap) {
    if (!track || !thumb) return;

    var cw = track.clientWidth;
    var sw = track.scrollWidth;
    var maxScroll = sw - cw;

    if (maxScroll <= 0 || !progressWrap) {
      if (progressWrap) progressWrap.classList.add('is-hidden');
      return;
    }

    progressWrap.classList.remove('is-hidden');

    var thumbW = (cw / sw) * 100;
    var left = maxScroll > 0 ? (track.scrollLeft / maxScroll) * (100 - thumbW) : 0;

    thumb.style.width = thumbW + '%';
    thumb.style.left = left + '%';
  }

  function updateScrollEnd(section, track) {
    if (!section || !track) return;

    var maxScroll = track.scrollWidth - track.clientWidth;
    var atEnd =
      maxScroll <= END_THRESHOLD || track.scrollLeft + track.clientWidth >= track.scrollWidth - END_THRESHOLD;

    if (isDesktop()) {
      section.classList.remove('is-scroll-end');
    } else {
      section.classList.toggle('is-scroll-end', atEnd);
    }
  }

  function bindSection(section) {
    if (section.hasAttribute('data-game-preview-empty')) return;

    var track = section.querySelector('[data-game-preview-track]');
    var thumb = section.querySelector('[data-game-preview-progress]');
    var progressWrap = section.querySelector('[data-game-preview-progress-wrap]');

    if (!track) return;

    var mq = window.matchMedia('(min-width: ' + DESKTOP_MIN + 'px)');

    function onScroll() {
      updateScrollEnd(section, track);
      if (!isDesktop()) {
        updateProgress(track, thumb, progressWrap);
      }
    }

    function onResize() {
      updateScrollEnd(section, track);
      if (!isDesktop()) {
        updateProgress(track, thumb, progressWrap);
      } else if (progressWrap) {
        progressWrap.classList.add('is-hidden');
      }
    }

    track.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onResize);

    function onMqChange() {
      onResize();
    }
    mq.addEventListener('change', onMqChange);

    onResize();
    onScroll();
  }

  function init() {
    document.querySelectorAll('[data-game-preview-cards]').forEach(bindSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
